import { Expose, Type } from 'class-transformer'
import { CampaignType } from './CampaignType'

export class CampaignListResponse {
  @Expose()
  @Type(() => CampaignType)
  data: CampaignType[]

  @Expose() total: number

  @Expose() page: number
}
